export const AvatarList = {
  Default: {
    EMPTY: "Нікого немає",
  },
};
